<template>
  <div style="width: 100%;">
    <div v-if="loading" class="col-12" style="margin-top: 20px;">
      <inline-alert-component
        message="Gráfico Donut — Ligações (Atendidas x Abandonadas)..."
        type="primary"
      ></inline-alert-component>
    </div>

    <div v-else class="card-charts my-3 px-3 py-3">
      <div class="sub-card-donut ligacoes">
        <h3 style="color:#000; text-align:center">
          <i class="fas fa-phone-alt"></i> Ligações (Atendidas x Abandonadas)
        </h3>
        <hr />
        <apexchart
          type="donut"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CombinedDonutCallsReport",
  props: {
    filter: {
      type: Object,
      required: true, // { startDate, endDate, queue, queueIds }
      default: () => ({ startDate: "", endDate: "", queue: "*", queueIds: "*" })
    },
  },
  data() {
    return {
      loading: false,
      series: [0, 0], // [Atendidas, Abandonadas]
      chartOptions: {
        chart: {
          id: "pizzaChartCombinedCallsReport",
          type: "donut",
          toolbar: {
            show: true,
            tools: { download: true }
          }
        },
        labels: ["Ligações atendidas", "Ligações abandonadas"],
        colors: ["#05e713", "#ff0000"],
        legend: { position: "top" },
        dataLabels: {
          offsetX: 50,
          offsetY: 2,
          style: {
            fontSize: "1.2em",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "1.8em",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total",
                  fontSize: "1.8em",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: "#373d3f",
                  formatter: (w) => {
                    const s = w?.globals?.seriesTotals || [0,0];
                    const total = s.reduce((a, b) => a + b, 0);
                    return total.toLocaleString("pt-BR");
                  },
                },
              },
            },
          },
        },
        noData: { text: "Sem dados para exibir no momento..." },
      },
    };
  },
  methods: {
    getCallsCombined() {
      if (!this.filter || !this.filter.startDate || !this.filter.endDate) return;

      this.loading = true;

      const params = new URLSearchParams({
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        // mantém a mesma convenção do seu backend
        queue: this.filter.queue || "*",
      });

      const url = `${window.location.href}/callsPizzaChartReport?${params.toString()}`;

      axios
        .get(url)
        .then(({ data }) => {
          // Somatórios (≤1min + >1min)
          const atendidasTotal =
            (data?.answered?.Menor1minEspera || 0) +
            (data?.answered?.Maior1minEspera || 0);
          const abandonadasTotal =
            (data?.abandoned?.Menor1minEspera || 0) +
            (data?.abandoned?.Maior1minEspera || 0);

          this.series = [atendidasTotal, abandonadasTotal];
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar gráfico combinado:", error);
          this.series = [0, 0];
          this.loading = false;
        });
    },
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler() {
        this.getCallsCombined();
      },
    },
  },
};
</script>

<style scoped>
.card-charts {
  display: flex;
  justify-content: center;
  width: 100%;
  border-radius: 12px;
  box-shadow: -5px -5px 8px rgba(255, 255, 255, 1),
    -2px -2px 12px rgba(255, 255, 255, 0.5),
    inset 2px 2px 4px rgba(255, 255, 255, 0.1), 5px 5px 8px rgba(0, 0, 0, 0.15);
}
.sub-card-donut { width: 35%; min-width: 250px; }
</style>
